import * as React from "react";
import { MadFragment, UserMadFragment } from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";
import Avatar from "../wombat-ui/Avatar";
import { FollowUpRoleBadge } from "./FollowUpRoleBadge";

type FollowUpPlateProps = {
  mad: MadFragment;
  user: UserMadFragment;
};

export const FollowUpPlate: React.FC<FollowUpPlateProps> = ({ mad, user }) => {
  const t = useTranslations();

  return (
    <div className="flex items-center justify-between px-6 py-4 my-2 text-sm rounded cursor-pointer bg-light-0">
      <div className="flex items-center w-5/12 space-x-4">
        <Avatar src={user.avatar} alt="user avatar" size={8} type="user" />
        <p className="text-sm truncate overflow-ellipsis">
          {mad.talent ? mad.talent.name : t("mads.unassigned")}
        </p>
      </div>
      <p className="w-4/12 text-sm truncate overflow-ellipsis">
        {mad.campaign.name}
      </p>
      <div className="w-3/12 text-right">
        <FollowUpRoleBadge mad={mad} user={user} />
      </div>
    </div>
  );
};
